import React, { useEffect, useState } from "react";
import Table from "../components/Table";

const Recommendations = (props) => {
  const [tableHeader] = useState([
    { label: "חברת ביטוח", sortable: false, engTrns: "logo" },
    { label: "מספר פוליסה", sortable: true, engTrns: "policyNumber" },
    // { label: "סוג ביטוח", sortable: true, engTrns: "insuranceType" },
    { label: "המלצה", sortable: false, engTrns: "recommendation" },
    { label: "חיסכון משוער (₪)", sortable: true, engTrns: "estimatedSavings" },
    { label: "", sortable: false, engTrns: "" },
  ]);
  const [tableHeader2] = useState([
    { label: "כיסוי מומלץ", sortable: true, engTrns: "recommendedCoverage" },
    {
      label: "הסבר והמלצה",
      sortable: true,
      engTrns: "explanationRecommendation",
    },
    {
      label: "עלות משוערת (₪ לשנה)",
      sortable: false,
      engTrns: "estimatedCost",
    },
    { label: "", sortable: false, engTrns: "" },
  ]);
  const [dataInsights, setDataInsights] = useState();
  const [dataInsightsAdditional, setDataInsightsAdditional] = useState();

  useEffect(() => {
    console.log("props", props.insights);

    if (props && props.insights && props.insights.length) {
      const formattedData = props?.insights[0].policies?.flatMap((item) => {
        console.log('item', item);
        
        return item?.recommendation?.map((rec) => ({
          policy_number: item?.policy_number,
          recommendation: rec,
          saving: item.saving,
          policy_id: item.policy_id,
          policyDetails: item.policyDetails,
          from: item.from,
          carrier: item.policyDetails?.carrier || item.policyDetails?.carrier_id
        }));
      });

      console.log('formattedData', formattedData);
      setDataInsights(formattedData || [])
      setDataInsightsAdditional(props?.insights[0].additions || [])
    }
  }, [props.insights]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, [props?.onboardingStep]);
  console.log("dataInsights",dataInsights)
  return (
    <>
      <div className="recommendations_table">
        <Table
          tableHeader={tableHeader}
          data={dataInsights}
          from="recommendations"
          title="המלצות עבור פוליסות קיימות"
          loading={loading}
          notFoundMessage="לממן"
          carrierLogos={props?.carrierLogos}
        />
      </div>

      <div className="recommendations_table">
        <Table
          tableHeader={tableHeader2}
          data={dataInsightsAdditional}
          from="recommendations1"
          title="המלצות נוספות"
          loading={loading}
          notFoundMessage="לממן"
        />
      </div>
    </>
  );
};

export default Recommendations;
